import {gql} from 'graphql-request';
import {useQuery} from '@tanstack/react-query';
import userStateGraphQLClient from '../services/UserStateApi/graphqlClient';

const query = gql`
  query getUser {
    user {
      addStoresDismissed
      bankInfoDismissed
      cashFundDismissed
      checklistDismissed
      giftNoteGuidanceDismissed
      TKRSGiftCards {
        totalBalance
      }
      storeCredit
      hasVisitedRegistry
      registryFirstVisitDate
      linkStoresDismissed
      onboarding {
        otherRegistriesQuestion
        welcomeQuestion
      }
      outOfStockDismissed
      shippingAddress {
        isSet
      }
      shippingAddressDismissed
      startWwsDismissed
      twoGiftsDismissed
      goal {
        goalId
      }
      interests {
        interestIds
      }
    }
  }
`;

export default function useGetUserState() {
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => userStateGraphQLClient.request(query),
  });
}
